import { render, staticRenderFns } from "./compromiso.vue?vue&type=template&id=24c95107"
import script from "./compromiso.vue?vue&type=script&lang=js"
export * from "./compromiso.vue?vue&type=script&lang=js"
import style0 from "./compromiso.vue?vue&type=style&index=0&id=24c95107&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports